import script from "./ReferMGMPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferMGMPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReferMGMPage.vue?vue&type=style&index=0&id=f3a6e596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a6e596"]])

export default __exports__